export const QUESTION_REPORT_TYPES = {
  Total: 'total',
  Latest: 'latest',
  Average: 'average',
};
